// Subtipos de alerta del módulo Medidas Cautelares (personas con brazalete
// GPS por orden judicial). Fuente única para el sidebar, el drawer y el
// pipeline de ingesta de MapV2.
//
// El backend (apiv2) manda `typeOfItem` EXPLÍCITO en cada alerta. Es
// deliberado: sin él, `_ingestHitAlerts` cae al fallback 'hitLpr' y el filtro
// de `alertedStatus` descartaría la alerta en silencio.

export const MC_ALERT_TYPES = {
  mcSalidaGeocerca: {
    label: 'Salió del perímetro',
    icon: 'mdi-map-marker-alert',
    // Prioridad operativa: es la alerta que exige respuesta inmediata.
    critica: true,
  },
  mcEntradaZonaProhibida: {
    label: 'Entró a zona prohibida',
    icon: 'mdi-map-marker-off',
    critica: true,
  },
  mcSinReporte: {
    label: 'Dispositivo sin reportar',
    icon: 'mdi-signal-off',
    critica: true,
  },
  mcBateriaBaja: {
    label: 'Batería baja',
    icon: 'mdi-battery-alert-variant-outline',
    critica: false,
  },
  mcOrdenVencida: {
    label: 'Orden judicial vencida',
    icon: 'mdi-calendar-remove',
    critica: false,
  },
  mcPruebaVidaFallida: {
    label: 'Prueba de vida fallida',
    icon: 'mdi-account-question',
    critica: true,
  },
}

export const MC_ENTITY_TYPE = 'medida_cautelar'

// Prefijo del monitor dinámico que se crea al seguir a una persona desde una
// alerta. La persona NO vive permanentemente en el mapa (requisito de la
// reunión: en el mapa principal solo se ven los alertamientos del día).
export function mcMonitorId(personaId) {
  return MC_ENTITY_TYPE + '-' + personaId
}

export function isMcAlert(typeOfItem) {
  return Object.prototype.hasOwnProperty.call(MC_ALERT_TYPES, typeOfItem)
}

export function mcAlertLabel(typeOfItem) {
  const t = MC_ALERT_TYPES[typeOfItem]
  return t ? t.label : 'Alerta de medida cautelar'
}

export function mcAlertIcon(typeOfItem) {
  const t = MC_ALERT_TYPES[typeOfItem]
  return t ? t.icon : 'mdi-account-alert'
}

export default MC_ALERT_TYPES
